import { isBrowser } from '../utils/environment';
import {
    sendOrvestoStatistics,
    trackViewEvent,
    trackCustomEvent,
} from '../utils/statistics/clientStatistics';

import {
    UPDATE_STATISTICS,
    UPDATE_STATISTICS_DATALAKE_CUSTOM_EVENT,
    UPDATE_STATISTICS_DATALAKE_VIEW,
} from '../actions/statistics';

const statistics = (store) => (next) => (action) => {
    if (isBrowser()) {
        const orvestoData = action.payload ? action.payload.orvestoData : undefined;
        const dataLake = action.payload && action.payload.dataLake;

        switch (action.type) {
            case UPDATE_STATISTICS:
                sendOrvestoStatistics(orvestoData);
                break;
            case UPDATE_STATISTICS_DATALAKE_VIEW:
                dataLake && trackViewEvent(dataLake);
                break;
            case UPDATE_STATISTICS_DATALAKE_CUSTOM_EVENT:
                trackCustomEvent(dataLake);
                break;
        }
    }

    return next(action);
};

export default statistics;
